import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1312Model } from './kymw1312.model';
import { PlessDialogServiceSub } from '../../../../../src/app/commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { KYMW1313Component } from '../../kymw13/kymw1313/kymw1313.component';
import { KYMW1312InputModel } from './vo/kymw1312-input.model';
import { KYMW1312GetSetPlanGoodsInfoModel } from './vo/kymw1312-get-set-plan-goods-info.model';
import { GetSetPromotionNoService } from './api-service/get-set-promotion-no.service';
import { GetSetPlanPromotionGoodsInfoService } from './api-service/get-set-plan-promotion-goods-info.service';
import { GetSetPlanGoodsInfoService } from './api-service/get-set-plan-goods-info.service';
import { RegistSetPlanPromotionGoodsService } from './api-service/regist-set-plan-promotion-goods.service';
import { KYMW1313OutputModel } from '../kymw1313/vo/kymw1313-output.model';
import { PlessAlert } from '../../../../../src/app/shared/pless-alert/pless-alert.component';
import { KYMW1313InputModel } from '../kymw1313/vo/kymw1313-input.model';
import { IEditableCollectionView } from '@grapecity/wijmo';
import { RadioLabelComponent } from '../../../../../src/app/commons/kymw02/radio-label/radio-label.component';
import { KYMW1312GetSetPlanPromotionNoModel } from './vo/kymw1312-get-set-plan-promotion-no.model';
import { KYMW1312GetSetPlanPromotionGoodsInfoModel } from './vo/kymw1312-get-set-plan-promotion-goods-info.model';
import { KYMW1312RegistSetPlanPromotionGoodsModel } from './vo/kymw1312-regist-set-plan-promotion-goods.model';
import { KYMW1312SetPlanPromotionGoodsInfoModel } from './vo/kymw1312-set-plan-promotion-goods-info.model';
import { KYMW1312SetPlanPromotionGoodsRegistModel } from './vo/kymw1312-set-plan-promotion-goods-regist.model';
import { PlessViewUtilsSub } from '../../../../../src/app/commons/kymw00/pless-view-utils-sub.service';
import { SelectionMode, Row, FlexGrid } from '@grapecity/wijmo.grid';
import { PlanGoodsLockService } from '../../../../../src/app/commons/kymw00/api-services/plan-goods-lock.service';

/**
 * セット企画設定画面を管理するクラス
 *
 * @export KYMW1312Component
 * @class KYMW1312Component
 */
@Component({
  selector: 'app-kymw1312',
  templateUrl: 'kymw1312.component.html',
  styleUrls: ['kymw1312.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1312Component extends PlessViewHelperSub implements OnInit {

  private readonly PROMOTION_DIV_SETPLAN: string = 'S';                         // プロモーション区分（S:セット企画）
  private readonly SETPLAN_DIV_PARENT: string = '1';                            // セット企画区分（1：親、2：子）
  private readonly SETPLAN_DIV_CHILD: string = '2';                             // セット企画区分（1：親、2：子）
  private readonly ABLE: string = '1';                                          // 可否区分（1:可能）
  private readonly UNABLE: string = '0';                                        // 可否区分（0:不可）
  private readonly HANDLING_ON: string = '1';                                   // 取扱フラグ（1:ON）
  private readonly DUTIES_FORM_DAILY_DIV_NO_PUBLICATION: string = '00';         // 業態区分（デイリー） 00：掲載なし
  private readonly DUTIES_FORM_SPOT_DIV_NO_PUBLICATION: string = '0';           // 業態区分（スポット） 0：掲載なし
  private readonly SELECT_ALL: string = '1';
  private readonly ARR_COOP_NAME: Array<any> = [
    this.kymw00Model.COOP_IB,
    this.kymw00Model.COOP_TO,
    this.kymw00Model.COOP_GU,
    this.kymw00Model.COOP_TI,
    this.kymw00Model.COOP_SA,
    this.kymw00Model.COOP_TK,
    this.kymw00Model.COOP_NA,
    this.kymw00Model.COOP_NI,
    this.kymw00Model.COOP_KU];

  private arrCheckMatrics: Array<any> = new Array<any>();                       // プロモーション情報一覧のマトリクスチェック配列
  private wkDeliveryLeadTimeType: string = <string>'';                          // 配達リード区分保存
  private promotionNoCopy: string = <string>'';

  // セット企画設定画面用インプットVO
  private inputVO: KYMW1312InputModel;

  // 親画面からの連携値
  KYMW1312Model: KYMW1312Model = new KYMW1312Model();

  setKYMW1312Parameter: Function;

  // 編集済みカウンタ
  public editCount = Number(0);

  // データグリッド
  @ViewChild('dtg_PromotionInfo', { static: true }) dtg_PromotionInfo: FlexGrid;
  @ViewChild('rbt_SetPlan', { static: true }) rbt_SetPlan: RadioLabelComponent;
  @ViewChild('txt_ApprovedNum', { static: true }) public txt_ApprovedNum: ElementRef;
  @ViewChild('cmb_PromotionNo', { static: true }) public cmb_PromotionNo: ElementRef;

  /**
   * Creates an instance of KYMW1312Component.
   * @param {PlessDialogService} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1312Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getSetPromotionNoService: GetSetPromotionNoService,
    private getSetPlanPromotionGoodsInfoService: GetSetPlanPromotionGoodsInfoService,
    private getSetPlanGoodsInfoService: GetSetPlanGoodsInfoService,
    private registSetPlanPromotionGoodsService: RegistSetPlanPromotionGoodsService,
    private planGoodsLockServiceSub: PlanGoodsLockService,
  ) {
    super(kymw00Model);

  }

  public getEditCount(): number {
    return this.editCount;
  }

  /**
   * インプットVO設定
   * @param inputVO インプットVO
   */
  public setInputVO(inputVO: any): void {

    // 受渡情報の設定（再描画時）
    this.inputVO = <KYMW1312InputModel>(inputVO);
    this.editCount += this.inputVO.editCount;

    this.KYMW1312Model.isGroupNormal = this.inputVO.isGroupNormal;

    // 処理区分のチェック
    if (this.inputVO.accessDiv === '1') {                                       // 処理区分(1：設定)の場合
      // 編集ロックが「閲覧モード」に切り替わった際、
      // または、受注コード、媒体区分コンボボックスの値が変更された場合、
      // 画面を閉じる
      if ((!this.inputVO.editLock                                               // 編集ロック
        && this.KYMW1312Model.editLock !== this.inputVO.editLock)               // 編集ロック
        || this.KYMW1312Model.orderCode !== this.inputVO.orderCode) {           // 受注コード)
        this.eventClose_CLICKHandler(null);
      }
      // InputVO ⇒ Manage
      this.KYMW1312Model.editLock = this.inputVO.editLock;                      // 編集ロック
      this.KYMW1312Model.editLockBtn = this.inputVO.editLock;                   // 編集ロック
      this.KYMW1312Model.orderCode = this.inputVO.orderCode;                    // 受注コード
      this.KYMW1312Model.promotionNo = this.inputVO.promotionNo;                // プロモーションＮＯ
      this.KYMW1312Model.promotionName = this.inputVO.promotionName;            // プロモーション名称
      this.KYMW1312Model.promotionInfo = new Array<any>();                      // プロモーション情報

      // セット企画プロモーション商品情報取得更新
      this.updateSetPlanPromotionGoodsInfo();
      this.ngOnInit();

      // 処理復帰
      return;
    }

    const getSetPlanGoodsInfoVO: KYMW1312GetSetPlanGoodsInfoModel = new KYMW1312GetSetPlanGoodsInfoModel();
    let blnAddFlg: boolean = <boolean>false;

    if (this.inputVO.pCodeList == null ||
      this.inputVO.pCodeList.length < 1) {
      this.KYMW1312Model.editLock = this.inputVO.editLock;
      this.KYMW1312Model.editLockBtn = this.inputVO.editLock;

      this.setEnabledBtn();
      return;
    }

    getSetPlanGoodsInfoVO.orderCode = this.KYMW1312Model.orderCode;
    getSetPlanGoodsInfoVO.accessDiv = this.inputVO.accessDiv;

    this.KYMW1312Model.sortDirection = this.dtg_PromotionInfo.collectionView.sortDescriptions.map(function (sortDesc) {
      return { property: sortDesc.property, ascending: sortDesc.ascending };
    });

    for (const inputPCode of this.inputVO.pCodeList) {
      blnAddFlg = true;
      for (const setPlanPromotionGoodsInfoVO of this.KYMW1312Model.promotionInfo) {
        if (inputPCode === setPlanPromotionGoodsInfoVO.pCode) {
          blnAddFlg = false;
          break;
        }
      }

      if (blnAddFlg) {
        getSetPlanGoodsInfoVO.pCodeList.push(inputPCode); 
      }
    }

    if (getSetPlanGoodsInfoVO.pCodeList.length < 1) {
      return;
    }

    // 企画商品情報取得要求をサーバに送信
    this.getSetPlanGoodsInfoService.execute(this.KYMW1312Model, getSetPlanGoodsInfoVO);
  }

  /**
   * 親画面の媒体変更時に媒体グループ区分が通常媒体かを設定する
   */
  public setIsGroupNormal(isGroupNormal) {
    this.KYMW1312Model.isGroupNormal = isGroupNormal;
  }

  /**
   * セット企画検索画面OutputVO設定
   */
  public setKYMW1313Parameter(outputVO: KYMW1313OutputModel): void {

    // 処理区分のチェック
    if (outputVO.accessDiv === '1') {                                           // 「1：検索」の場合
      // VO⇒Manage
      this.KYMW1312Model.accessPromotionName = outputVO.promotionName;
      this.KYMW1312Model.accessPCode = outputVO.pCode;
      this.KYMW1312Model.accessSetDelivGoodsName = outputVO.setDelivGoodsName;
      this.KYMW1312Model.accessCoopCode = outputVO.coopCode;
      this.KYMW1312Model.accessClassCode = outputVO.classCode;
    } else if (outputVO.accessDiv === '2') {                                    // 「2：選択」の場合
      this.KYMW1312Model.promotionNo = outputVO.promotionNo;

      // セット企画プロモーション商品情報取得要求をサーバに送信
      this.getSetPlanPromotionGoodsInfoService.execute(this.KYMW1312Model, this.createGetSetPlanPromotionGoodsInfoVO());
    }
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1312';
    this.KYMW1312Model.KYMW1312Component = this;
    this.planGoodsLockService = this.planGoodsLockServiceSub;

    this.dtg_PromotionInfo.columnHeaders.rows[0].height = 70;
    // 行ヘッダの幅を0にしてレイアウト設定
    this.dtg_PromotionInfo.rowHeaders.columns[0].width = 0;

    this.dtg_PromotionInfo.itemsSourceChanged.addHandler(() => {
      this.dtg_PromotionInfo.select(-1, -1);
    });

    // InputVO ⇒ Manage
    this.KYMW1312Model.editLock = this.inputVO.editLock;                        // 編集ロック
    this.KYMW1312Model.editLockBtn = this.inputVO.editLock;                     // 編集ロック
    this.KYMW1312Model.orderCode = this.inputVO.orderCode;                      // 受注コード
    this.KYMW1312Model.promotionNo = this.inputVO.promotionNo;                  // プロモーションＮＯ
    this.KYMW1312Model.isGroupNormal = this.inputVO.isGroupNormal;

    // セット企画プロモーションＮＯ取得要求をサーバに送信
    this.getSetPromotionNoService.execute(this.KYMW1312Model, this.createGetSetPlanPromotionNoVO());

    this.cmb_PromotionNo.nativeElement.focus();

    // 編集カウントをクリア
    this.editCount = 0;
  }

  /**
   * 項目変更時イベント
   */
  public eventEditHandler(event: Event): void {
    this.editCount++;
  }

  /**
   * 設定単位ラジオボタングループ_アイテムクリック時に呼び出されるメソッド
   *
   * @param event コールバック・イベントへの参照
   */
  public eventUnit_CHANGEHandler(event: Event): void {
    this.setEnabledUnit();
  }

  /**
   * プロモーションＮＯコンボボックス_チェンジ時に呼び出されるメソッド
   *
   * @param event コールバック・イベントへの参照
   */
  public eventNo_CHANGEHandler(event: Event): void {
    if (this.KYMW1312Model.promotionNo === '') {
      // 編集が行われている場合、メッセージを表示
      if (this.editCount > 0) {
        this.dialogService.openAlertGetMessage('Q0107', ['セット企画プロモーション情報'],
          (closeDetail: number) => {
            if (closeDetail === PlessAlert.Yes) {
              // プロモーションNOを退避
              this.promotionNoCopy = this.KYMW1312Model.promotionNo;
              // 編集カウントをクリア
              this.clearEditCount();
              // 画面項目初期化
              this.initDisplay();
              // ボタン活性制御
              this.setEnabledBtn();
            } else {
              this.initPromotionNo(this.promotionNoCopy);
            }
          });
      } else {
        // 画面項目初期化
        this.initDisplay();
        // ボタン活性制御
        this.setEnabledBtn();
      }
    } else {
      // 編集が行われている場合、メッセージを表示
      if (this.editCount > 0) {
        this.dialogService.openAlertGetMessage('Q0107', ['セット企画プロモーション情報'],
          (closeDetail: number) => {
            if (closeDetail === PlessAlert.Yes) {
              // プロモーションNOを退避
              this.promotionNoCopy = this.KYMW1312Model.promotionNo;
              // 編集カウントをクリア
              this.clearEditCount();
              // セット企画プロモーション商品情報取得
              this.getPromotionInfo();
            } else {
              this.initPromotionNo(this.promotionNoCopy);
            }
          });
      } else {
        // プロモーションNOを退避
        this.promotionNoCopy = this.KYMW1312Model.promotionNo;
        // セット企画プロモーション商品情報取得
        this.getPromotionInfo();
      }
    }
  }

  /**
   * セット企画プロモーション商品情報を取得する
   */
  private getPromotionInfo(): void {
    // セット企画プロモーション商品情報取得要求をサーバに送信
    this.getSetPlanPromotionGoodsInfoService.execute(this.KYMW1312Model, this.createGetSetPlanPromotionGoodsInfoVO());
  }

  /**
   * セット企画プロモーションNOを設定する
   */
  private initPromotionNo(promotionNoParam: string): void {
    // 退避したプロモーションNOを設定
    this.KYMW1312Model.promotionNo = promotionNoParam;
  }

  /**
   * 検索ボタン_クリック時に呼び出されるメソッド
   *
   * @param event コールバック・イベントへの参照
   */
  public eventSearch_CLICKHandler(event: Event): void {

    const componentRef = this.dialogService.openModal(KYMW1313Component);
    const instance = componentRef.componentInstance as KYMW1313Component;
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
    instance.setKYMW1313Parameter = (outputVo: KYMW1313OutputModel) => {
      this.setKYMW1313Parameter(outputVo);
    };

    // パラメータ設定
    const kymw1313vo: KYMW1313InputModel = new KYMW1313InputModel();

    kymw1313vo.orderCode = this.KYMW1312Model.orderCode;                        // 受注コード
    kymw1313vo.promotionName = this.KYMW1312Model.accessPromotionName;          // 前回検索条件.プロモーション名称
    kymw1313vo.pCode = this.KYMW1312Model.accessPCode;                          // 前回検索条件.Ｐコード
    kymw1313vo.setDelivGoodsName = this.KYMW1312Model.accessSetDelivGoodsName;  // 前回検索条件.セット企画商品名
    kymw1313vo.coopCode = this.KYMW1312Model.accessCoopCode;                    // 前回検索条件.会員生協コード
    kymw1313vo.classCode = this.KYMW1312Model.accessClassCode;                  // 前回検索条件.部門コード

    instance.setInterfaceParam(kymw1313vo);
  }

  /**
   * 一括反映ボタン_クリック時に呼び出されるメソッド
   *
   * @param event コールバック・イベントへの参照
   */
  public eventReflection_CLICKHandler(event: Event): void {

    // 「セット企画数量」が未入力の場合
    if (this.KYMW1312Model.approvedNum === '') {
      this.dialogService.openAlertGetMessage('W0001', ['セット企画数量'], null);
      return;
    }

    // 「セット企画数量」の入力値が0の場合
    if (Number(this.KYMW1312Model.approvedNum) <= 0) {
      this.dialogService.openAlertGetMessage('E0142', ['セット企画数量', '1'], null);
      return;
    }

    // 「プロモーション情報一覧」での選択行数が0件の場合
    if (this.dtg_PromotionInfo.selectedItems.length <= 0) {
      this.dialogService.openAlertGetMessage('E0103', ['商品'], null);
      return;
    }

    // 全ての生協チェックボックスが選択解除となっている場合
    if (this.KYMW1312Model.coopIB === false &&
      this.KYMW1312Model.coopTO === false &&
      this.KYMW1312Model.coopGU === false &&
      this.KYMW1312Model.coopTI === false &&
      this.KYMW1312Model.coopSA === false &&
      this.KYMW1312Model.coopTK === false &&
      this.KYMW1312Model.coopNA === false &&
      this.KYMW1312Model.coopNI === false &&
      this.KYMW1312Model.coopKU === false) {

      this.dialogService.openAlertGetMessage('E0103', ['反映対象の生協'], null);
      return;
    }

    // 「プロモーション情報一覧」への反映を行う。
    this.reflectPromotion(this.KYMW1312Model.approvedNum, this.KYMW1312Model.approvedPrice);
  }

  /**
   * 行削除ボタン_クリック時に呼び出されるメソッド
   *
   * @param event コールバック・イベントへの参照
   */
  public eventDelRow_CLICKHandler(event: Event): void {

    // 選択行数が0件の場合
    if (this.dtg_PromotionInfo.selection.row === -1) {
      this.dialogService.openAlertGetMessage('E0103', ['商品'], null);
      return;
    }

    // 編集モードの場合、以下の処理を行う。
    if (this.KYMW1312Model.editLock) {
      // ロック情報リリース
      this.LockUtilForPlanGoods('RELEASE',
        this.KYMW1312Model.orderCode,
        this.KYMW1312Model.promotionInfo[this.dtg_PromotionInfo.selection.row].mediumType,
        this.KYMW1312Model.promotionInfo[this.dtg_PromotionInfo.selection.row].pCode,
        null,
        null,
        null,
        null,
        false);
      // 選択中の商品を「プロモーション情報一覧」から削除する。
      const cv: IEditableCollectionView = this.dtg_PromotionInfo.editableCollectionView;
      cv.removeAt(this.dtg_PromotionInfo.selection.row);

      this.setEnabledBtn();

      // 編集カウントをインクリメント
      this.editCount++;
    }
  }

  /**
   * 全削除ボタン_クリック時に呼び出されるメソッド
   *
   * @param event コールバック・イベントへの参照
   */
  public eventDelAll_CLICKHandler(event: Event): void {

    // ロック情報リリース
    if (this.KYMW1312Model.promotionInfo != null &&
      this.KYMW1312Model.promotionInfo.length > 0) {

      for (const vo of this.KYMW1312Model.promotionInfo) {
        // ロック情報リリース
        this.LockUtilForPlanGoods('RELEASE',
          this.KYMW1312Model.orderCode,
          vo.mediumType,
          vo.pCode,
          null,
          null,
          null,
          null,
          false);
      }
    }

    // 「プロモーション情報一覧」内の全商品を削除する。
    const cv: IEditableCollectionView = this.dtg_PromotionInfo.editableCollectionView;
    for (let i: number = cv.items.length; i >= 0; i--) {
      cv.removeAt(i);
    }

    this.setEnabledBtn();

    // 編集カウントをインクリメント
    this.editCount++;
  }

  /**
   * 設定ボタン_クリック時に呼び出されるメソッド
   *
   * @param event コールバック・イベントへの参照
   */
  public eventRegist_CLICKHandler(event: Event): void {

    this.KYMW1312Model.promotionNo = String(this.KYMW1312Model.promotionNo);

    const strDiv: string = <string>'セット企画';
    let strMes: string = <string>'';

    if (this.KYMW1312Model.promotionInfo.length < 1) {
      if (this.KYMW1312Model.promotionNo.length < 1) {
        this.dialogService.openAlertGetMessage('E0109', [], null);
        return;
      }
      // 確認メッセージを表示
      this.dialogService.openAlertGetMessage('Q0106', [strDiv], (closeDetail: number) => this.eventDeleteConfirm_CLICKHandler(closeDetail));
    } else {
      let cntParent: number = <number>0;                                        // 親商品カウンタ
      let cntChildren: number = <number>0;                                      // 子商品カウンタ
      const p: number = <number>0;                                              // 親商品の「今回供給価格」

      this.arrCheckMatrics = new Array(9);
      this.wkDeliveryLeadTimeType = null;                                       // 配達リード区分保存クリア

      for (const vo1 of this.KYMW1312Model.promotionInfo) {
        // 全ての生協の「セット企画数量」が未入力の場合
        if (vo1.approvedNumIB.length < 1 &&
          vo1.approvedNumTO.length < 1 &&
          vo1.approvedNumGU.length < 1 &&
          vo1.approvedNumTI.length < 1 &&
          vo1.approvedNumSA.length < 1 &&
          vo1.approvedNumTK.length < 1 &&
          vo1.approvedNumNA.length < 1 &&
          vo1.approvedNumNI.length < 1 &&
          vo1.approvedNumKU.length < 1) {

          strMes = '『' + vo1.pCode + ':' + vo1.guideGoodsName + '』のセット企画数量';
          this.dialogService.openAlertGetMessage('W0001', [strMes], null);
          return;
        }

        let pCodeName: string = <string>'';
        /* 単項目チェック */
        if (this.checkSetPlanSingleTerm(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_IB,
          vo1.thisTimeSupplyPriceIB,
          vo1.approvedNumIB) === false) {
          return;
        }
        if (this.checkSetPlanSingleTerm(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_TO,
          vo1.thisTimeSupplyPriceTO,
          vo1.approvedNumTO) === false) {
          return;
        }
        if (this.checkSetPlanSingleTerm(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_GU,
          vo1.thisTimeSupplyPriceGU,
          vo1.approvedNumGU) === false) {
          return;
        }
        if (this.checkSetPlanSingleTerm(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_TI,
          vo1.thisTimeSupplyPriceTI,
          vo1.approvedNumTI) === false) {
          return;
        }
        if (this.checkSetPlanSingleTerm(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_SA,
          vo1.thisTimeSupplyPriceSA,
          vo1.approvedNumSA) === false) {
          return;
        }
        if (this.checkSetPlanSingleTerm(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_TK,
          vo1.thisTimeSupplyPriceTK,
          vo1.approvedNumTK) === false) {
          return;
        }
        if (this.checkSetPlanSingleTerm(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_NA,
          vo1.thisTimeSupplyPriceNA,
          vo1.approvedNumNA) === false) {
          return;
        }
        if (this.checkSetPlanSingleTerm(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_NI,
          vo1.thisTimeSupplyPriceNI,
          vo1.approvedNumNI) === false) {
          return;
        }
        if (this.checkSetPlanSingleTerm(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_KU,
          vo1.thisTimeSupplyPriceKU,
          vo1.approvedNumKU) === false) {
          return;
        }

        /* 関連チェック */
        // 「セット企画数量」に値がある場合、「成立価格」が未入力ならば、エラー
        if (this.checkApprovedPrice(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_IB,
          vo1.handlingFlgIB,
          vo1.approvedNumIB,
          vo1.approvedPriceIB) === false) {
          return;
        }
        if (this.checkApprovedPrice(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_TO,
          vo1.handlingFlgTO,
          vo1.approvedNumTO,
          vo1.approvedPriceTO) === false) {
          return;
        }
        if (this.checkApprovedPrice(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_GU,
          vo1.handlingFlgGU,
          vo1.approvedNumGU,
          vo1.approvedPriceGU) === false) {
          return;
        }
        if (this.checkApprovedPrice(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_TI,
          vo1.handlingFlgTI,
          vo1.approvedNumTI,
          vo1.approvedPriceTI) === false) {
          return;
        }
        if (this.checkApprovedPrice(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_SA,
          vo1.handlingFlgSA,
          vo1.approvedNumSA,
          vo1.approvedPriceSA) === false) {
          return;
        }
        if (this.checkApprovedPrice(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_TK,
          vo1.handlingFlgTK,
          vo1.approvedNumTK,
          vo1.approvedPriceTK) === false) {
          return;
        }
        if (this.checkApprovedPrice(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_NA,
          vo1.handlingFlgNA,
          vo1.approvedNumNA,
          vo1.approvedPriceNA) === false) {
          return;
        }
        if (this.checkApprovedPrice(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_NI,
          vo1.handlingFlgNI,
          vo1.approvedNumNI,
          vo1.approvedPriceNI) === false) {
          return;
        }
        if (this.checkApprovedPrice(vo1.pCode,
          vo1.guideGoodsName,
          this.kymw00Model.COOP_KU,
          vo1.handlingFlgKU,
          vo1.approvedNumKU,
          vo1.approvedPriceKU) === false) {
          return;
        }

        if (vo1.setPlanDiv === this.SETPLAN_DIV_PARENT) {
          // 親商品ならば
          cntParent++;

          /* 関連項目チェック */
          // 「セット企画数量」に値がある場合、「成立価格」が未入力ならば、エラーメッセージを表示する。
          // 「セット企画区分」が'1：親'、かつ「単品注文可否区分」が'1：可能'でない場合
          if (vo1.singleOrderFlag !== this.ABLE) {
            this.dialogService.openAlertGetMessage('E0107', ['セット企画区分で「1：親」', '単品注文可否区分では「1：可能」'], null);
            return;
          }

          // 「業態区分（デイリー）」が'00：掲載なし'以外、かつ「セット企画区分」が'1：親'の場合
          if (vo1.dutiesFormDailyDiv !== this.DUTIES_FORM_DAILY_DIV_NO_PUBLICATION) {
            pCodeName = 'デイリー媒体掲載商品『' + vo1.pCode + ':' + vo1.guideGoodsName + '』';
            this.dialogService.openAlertGetMessage('E0265', [pCodeName, 'セット企画（親商品）'], null);
            return;
          }

        } else {
          // 子商品ならば
          cntChildren++;
          // 親商品の「今回供給価格」のセット

          // 「業態区分（デイリー）」が'00：掲載なし'以外、かつ「セット企画区分」が'2：子'、かつ「単品注文可否区分」が'0：不可'の場合
          if (vo1.dutiesFormDailyDiv !== this.DUTIES_FORM_DAILY_DIV_NO_PUBLICATION &&
            vo1.singleOrderFlag === this.UNABLE) {
            pCodeName = 'デイリー媒体掲載商品『' + vo1.pCode + ':' + vo1.guideGoodsName + '』';
            this.dialogService.openAlertGetMessage('E0265', [pCodeName, 'セット企画（単品注文不可・子商品）'], null);
            return;
          }
        }

        // 「業態区分（スポット）」が'0：掲載なし'以外の場合
        if (vo1.dutiesFormSpotDiv !== this.DUTIES_FORM_SPOT_DIV_NO_PUBLICATION) {
          pCodeName = 'スポット媒体掲載商品『' + vo1.pCode + ':' + vo1.guideGoodsName + '』';
          this.dialogService.openAlertGetMessage('E0265', [pCodeName, 'セット企画'], null);
          return;
        }

        // 取扱商品のうち、いずれかの「配達リード区分」が他と異なる場合のチェック
        if (!this.checkDeliveryLeadTimeType(vo1.handlingFlgIB, vo1.approvedPriceIB, vo1.deliveryLeadTimeTypeIB) ||
          !this.checkDeliveryLeadTimeType(vo1.handlingFlgTO, vo1.approvedPriceTO, vo1.deliveryLeadTimeTypeTO) ||
          !this.checkDeliveryLeadTimeType(vo1.handlingFlgGU, vo1.approvedPriceGU, vo1.deliveryLeadTimeTypeGU) ||
          !this.checkDeliveryLeadTimeType(vo1.handlingFlgTI, vo1.approvedPriceTI, vo1.deliveryLeadTimeTypeTI) ||
          !this.checkDeliveryLeadTimeType(vo1.handlingFlgSA, vo1.approvedPriceSA, vo1.deliveryLeadTimeTypeSA) ||
          !this.checkDeliveryLeadTimeType(vo1.handlingFlgTK, vo1.approvedPriceTK, vo1.deliveryLeadTimeTypeTK) ||
          !this.checkDeliveryLeadTimeType(vo1.handlingFlgNA, vo1.approvedPriceNA, vo1.deliveryLeadTimeTypeNA) ||
          !this.checkDeliveryLeadTimeType(vo1.handlingFlgNI, vo1.approvedPriceNI, vo1.deliveryLeadTimeTypeNI) ||
          !this.checkDeliveryLeadTimeType(vo1.handlingFlgKU, vo1.approvedPriceKU, vo1.deliveryLeadTimeTypeKU)) {

          this.dialogService.openAlertGetMessage('E0265', ['配達リード区分が異なる商品', 'セット企画'], null);
          return;

        }
      }

      /* 関連項目チェック */
      if (cntParent <= 0) {
        // 「セット企画区分」が'1：親'の商品が0件の場合
        this.dialogService.openAlertGetMessage('E0103', ['親商品'], null);
        return;
      } else if (cntParent > 1) {
        // 「セット企画区分」が'1：親'の商品が2件以上の場合
        this.dialogService.openAlertGetMessage('E0201', ['親商品', '1'], null);
        return;
      }

      if (cntChildren <= 0) {
        // 「セット企画区分」が'2：子'の商品が0件の場合
        this.dialogService.openAlertGetMessage('E0105', ['子商品'], null);
        return;
      }

      /* プロモーション情報一覧のマトリクスチェック */
      // プロモーション情報一覧の各会員生協について、集計オブジェクトを作る。
      this.arrCheckMatrics = this.createArrCheckMatrics(this.KYMW1312Model.promotionInfo);

      // 生成した各会員生協の集計値について以下のチェックを行う。
      for (let i: number = <number>0; i < this.ARR_COOP_NAME.length; i++) {
        if (this.arrCheckMatrics[i].handlingFlg === this.HANDLING_ON) {         // 親商品の取扱フラグが「1:ON」の場合
          if (this.arrCheckMatrics[i].approvedNum > 0) {                        // 親商品のセット企画数量が1以上の場合
            // 子商品数量がゼロの場合、エラーメッセージを表示する。
            if (this.arrCheckMatrics[i].childrenNum <= 0) {
              this.dialogService.openAlertGetMessage('E0105', ['子商品（' + this.arrCheckMatrics[i].coopName + '）'], null);
              return;
            }
            // 親商品の今回供給価格と子商品成立価格合計が一致しない場合
            if (this.arrCheckMatrics[i].thisTimeSupplyPrice !== this.arrCheckMatrics[i].approvedPriceSum) {
              this.dialogService.openAlertGetMessage('E0121', [this.arrCheckMatrics[i].coopName + ':親商品の今回供給価格', '子商品の成立価格の合計'], null);
              return;
            }
          } else {                                                              // 親商品のセット企画数量がゼロ、あるいは未入力の場合
            // 子商品数量が1以上の場合、エラーメッセージを表示する。
            if (this.arrCheckMatrics[i].childrenNum > 0) {
              this.dialogService.openAlertGetMessage('E0103', ['親商品（' + this.arrCheckMatrics[i].coopName + '）'], null);
              return;
            }
          }
        } else {                                                                // 親商品の取扱フラグが「1:ON」以外の場合
          // 子商品数量が1以上の場合、エラーメッセージを表示する。
          if (this.arrCheckMatrics[i].childrenNum > 0) {
            this.dialogService.openAlertGetMessage('E0103', ['親商品（' + this.arrCheckMatrics[i].coopName + '）'], null);
            return;
          }
        }
      }

      // 変数定義
      const promotList: Array<any> = this.KYMW1312Model.promotionInfo;
      let loopCnt: number = <number>0;                                          // ループカウンタ
      let consumeTaxRate: string = <string>'';                                  // 消費税率
      let consumeTaxRateFlg: boolean = <boolean>false;                          // 消費税率チェックフラグ(true:差異あり、false:差異なし)

      // 消費税率チェック処理
      for (const vo of promotList) {                                            // プロモーション情報数分ループ

        // 消費税率の比較
        if (loopCnt > 0 && consumeTaxRate !== vo.consumeTaxRate) {              // 異なる場合
          consumeTaxRateFlg = true;
          break;
        }

        loopCnt++;
        consumeTaxRate = vo.consumeTaxRate;
      }

      // 消費税率チェックフラグのチェック
      if (consumeTaxRateFlg) {                                                  // 「true:差異あり」の場合
        this.dialogService.openAlertGetMessage('Q0155', [], (closeDitail: number) => {
          this.eventConsumeTaxRateConfirm_CLICKHandler(closeDitail);
        });
        return;
      }

      if (this.KYMW1312Model.promotionNo.length > 0) {
        this.dialogService.openAlertGetMessage('Q0105', [strDiv], (closeDitail: number) => {
          this.eventRegistConfirm_CLICKHandler(closeDitail);
        });
      } else {
        this.dialogService.openAlertGetMessage('Q0104', [strDiv], (closeDitail: number) => {
          this.eventRegistConfirm_CLICKHandler(closeDitail);
        });
      }
    }
  }

  /**
   * 取扱商品のうち、いずれかの「配達リード区分」が他と異なる場合のチェック
   * @param hanlingFlg : 取扱フラグ
   * @param approvedPrice : 成立価格
   * @param type : 配達リード区分
   * @return : OK:true, NG:false
   */
  private checkDeliveryLeadTimeType(hanlingFlg: string, approvedPrice: string, type: string): boolean {
    if (type == null || type.length <= 0) {
      return true;
    }

    if (hanlingFlg === this.HANDLING_ON && approvedPrice) {
      if (this.wkDeliveryLeadTimeType) {
        if (this.wkDeliveryLeadTimeType === type) {
          return true;
        } else {
          return false;
        }
      } else {
        this.wkDeliveryLeadTimeType = type;
        return true;
      }
    }
    return true;
  }

  /**
   * 閉じるボタンクリック時の処理
   */
  public eventClose_CLICKHandler(event: MouseEvent): void {
    // ロック情報リリース
    this.releaseLock();

    // 編集が行われている場合、メッセージを表示
    if (this.editCount > 0) {
      this.dialogService.openAlertGetMessage('Q0107', ['セット企画プロモーション情報'],
        (closeDetail: number) => {
          if (closeDetail === PlessAlert.Yes) {
            // プロモーションNOを退避
            this.closeFunction();
          }
        });
    } else {
      this.closeFunction();
    }
  }

  /**
   * ロック情報リリース
   */
  public releaseLock(): void {
    if (this.KYMW1312Model.promotionInfo != null &&
      this.KYMW1312Model.promotionInfo.length > 0) {
      for (const vo of this.KYMW1312Model.promotionInfo) {
        this.LockUtilForPlanGoods('RELEASE',
          this.KYMW1312Model.orderCode,
          vo.mediumType,
          vo.pCode,
          null,
          null,
          null,
          null,
          false);
      }
    }
  }

  /**
   * 消費税率確認メッセージ_ボタンクリック時の処理
   *
   * @param event コールバック・イベントへの参照
   */
  public eventConsumeTaxRateConfirm_CLICKHandler(closeDetail: number): void {
    const strDiv: string = <string>'セット企画';
    if (closeDetail === PlessAlert.Yes) {
      if (this.KYMW1312Model.promotionNo.length > 0) {
        this.dialogService.openAlertGetMessage('Q0105', [strDiv], (detail: number) => {
          this.eventRegistConfirm_CLICKHandler(detail);
        });
      } else {
        this.dialogService.openAlertGetMessage('Q0104', [strDiv], (detail: number) => {
          this.eventRegistConfirm_CLICKHandler(detail); 
        });
      }
    }
  }

  /**
   * 設定確認メッセージ_ボタンクリック時の処理
   *
   * @param event コールバック・イベントへの参照
   */
  public eventRegistConfirm_CLICKHandler(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // 登録要求をサーバに送信
      this.registSetPlanPromotionGoodsService.execute(this.KYMW1312Model, this.createRegistSetPlanPromotionGoodsVO());

      // 編集カウンタをクリアする
      this.editCount = 0;
    }
  }

  /**
   * 削除確認メッセージ_ボタンクリック時の処理
   *
   * @param event コールバック・イベントへの参照
   */
  public eventDeleteConfirm_CLICKHandler(closeDetail: number): void {
    if (closeDetail === PlessAlert.Yes) {
      // セット企画プロモーション商品登録要求を送信し、セット企画プロモーション情報を削除
      this.registSetPlanPromotionGoodsService.execute(this.KYMW1312Model, this.createRegistSetPlanPromotionGoodsVO());

      // 要求を行った後、プロモーションNOをクリアする。
      this.inputVO.promotionNo = '';

      // 編集カウンタをクリアする
      this.editCount = 0;
    }
  }

  /**
   * 排他ロック失敗時の処理を行う
   */
  public lockErr_Handler({ event, result }: { event: any; result: any; }): void {
    this.KYMW1312Model.editLock = false;
    this.setEnabledBtn();

    let UserID: string = <string>'';
    if (result.result.obj.UnlockedInfo.Catalog[0] != null ) {
      UserID = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserId) + ']';
    } else if (result.result.obj.UnlockedInfo.Page[0] != null ) {
      UserID = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserId) + ']';
    } else {
      UserID = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserId) + ']';
    }
    this.dialogService.openAlertGetMessage('E0268', [UserID]);
  }

  /**
   * 排他ロック成功時の処理を行う
   */
  public lockScc_Handler(event: any): void {
    this.KYMW1312Model.editLock = true;
    this.setEnabledBtn();
  }

  /**
   * 排他ロック失敗時の処理を行う
   */
  public listLockErr_Handler({ event, result }: { event: any; result: any; }): void {
    this.KYMW1312Model.editLock = false;
    this.setEnabledBtn();

    let UserID: string = <string>'';
    if (result.result.obj.UnlockedInfo.Catalog[0] != null ) {
      UserID = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserId) + ']';
    } else if (result.result.obj.UnlockedInfo.Page[0] != null ) {
      UserID = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserId) + ']';
    } else {
      UserID = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserId) + ']';
    }
    this.dialogService.openAlertGetMessage('E0268', [UserID]);
    this.KYMW1312Model.listLockFlg = true;
  }

  /**
   * 排他ロック失敗時の処理を行う
   */
  public listLockScc_Handler(event: any): void {
    if (!this.KYMW1312Model.listLockFlg) {
      this.KYMW1312Model.editLock = true;
      this.setEnabledBtn();
    }
  }

  /**
   * 画面項目の初期化
   */
  public initDisplay(): void {

    // ロック情報リリース
    if (this.KYMW1312Model.promotionInfo != null &&
      this.KYMW1312Model.promotionInfo.length > 0) {
      for (const vo of this.KYMW1312Model.promotionInfo) {
        this.LockUtilForPlanGoods('RELEASE',
          this.KYMW1312Model.orderCode,
          vo.mediumType,
          vo.pCode,
          null,
          null,
          null,
          null,
          false);
      }
    }

    // セット企画プロモーション名称
    this.KYMW1312Model.promotionName = '';

    // 区分
    this.KYMW1312Model.promotionDiv = this.PROMOTION_DIV_SETPLAN;

    // 設定単位
    this.KYMW1312Model.setUnit = this.SELECT_ALL;
    this.setEnabledUnit();

    // 設定値一括反映
    this.KYMW1312Model.approvedNum = '1';
    this.KYMW1312Model.approvedPrice = '';

    // セット企画プロモーション情報
    this.KYMW1312Model.promotionInfo = new Array<any>();

    this.rbt_SetPlan.elementRef.nativeElement.focus();
  }

  /**
   * ボタンの活性制御
   */
  public setEnabledBtn(): void {

    // 一括反映,行削除,全削除
    if (this.KYMW1312Model.editLock === false || this.KYMW1312Model.promotionInfo.length === 0) {
      this.KYMW1312Model.disabledReflection = true;
      this.KYMW1312Model.disabledDelAll = true;
      this.KYMW1312Model.disabledDelRow = true;
      this.dtg_PromotionInfo.isReadOnly = true;
    } else {
      this.KYMW1312Model.disabledReflection = false;
      this.KYMW1312Model.disabledDelAll = false;
      this.KYMW1312Model.disabledDelRow = false;
      this.dtg_PromotionInfo.isReadOnly = false;
    }

    // 設定,その他
    if (this.KYMW1312Model.editLock === true) {
      this.enabledForViewer(true);
      if (this.KYMW1312Model.promotionInfo.length <= 0) {
        if (!PlessViewUtilsSub.isEmpty(this.KYMW1312Model.promotionNo)) {
          this.KYMW1312Model.disabledRegist = false;
        } else {
          this.KYMW1312Model.disabledRegist = true;
        }
      } else {
        this.KYMW1312Model.disabledRegist = false;
      }
    } else {
      this.KYMW1312Model.disabledRegist = true;
      this.enabledForViewer(false);
    }
  }

  /**
   * 生協単位による画面項目活性制御
   */
  public setEnabledUnit(): void {

    if (!this.KYMW1312Model.editLock) {
      return;
    }

    if (this.KYMW1312Model.setUnit === this.SELECT_ALL) {
      // 生協活性制御
      this.KYMW1312Model.disabledCoopIB = true;
      this.KYMW1312Model.disabledCoopTO = true;
      this.KYMW1312Model.disabledCoopGU = true;
      this.KYMW1312Model.disabledCoopTI = true;
      this.KYMW1312Model.disabledCoopSA = true;
      this.KYMW1312Model.disabledCoopTK = true;
      this.KYMW1312Model.disabledCoopNA = true;
      this.KYMW1312Model.disabledCoopNI = true;
      this.KYMW1312Model.disabledCoopKU = true;

      // 生協選択
      this.KYMW1312Model.coopIB = true;
      this.KYMW1312Model.coopTO = true;
      this.KYMW1312Model.coopGU = true;
      this.KYMW1312Model.coopTI = true;
      this.KYMW1312Model.coopSA = true;
      this.KYMW1312Model.coopTK = true;
      this.KYMW1312Model.coopNA = true;
      this.KYMW1312Model.coopNI = true;
      this.KYMW1312Model.coopKU = true;
    } else {
      // 生協活性制御
      this.KYMW1312Model.disabledCoopIB = false;
      this.KYMW1312Model.disabledCoopTO = false;
      this.KYMW1312Model.disabledCoopGU = false;
      this.KYMW1312Model.disabledCoopTI = false;
      this.KYMW1312Model.disabledCoopSA = false;
      this.KYMW1312Model.disabledCoopTK = false;
      this.KYMW1312Model.disabledCoopNA = false;
      this.KYMW1312Model.disabledCoopNI = false;
      this.KYMW1312Model.disabledCoopKU = false;

      // 生協選択
      this.KYMW1312Model.coopIB = false;
      this.KYMW1312Model.coopTO = false;
      this.KYMW1312Model.coopGU = false;
      this.KYMW1312Model.coopTI = false;
      this.KYMW1312Model.coopSA = false;
      this.KYMW1312Model.coopTK = false;
      this.KYMW1312Model.coopNA = false;
      this.KYMW1312Model.coopNI = false;
      this.KYMW1312Model.coopKU = false;
    }
  }

  /**
   * 単項目入力チェック
   *
   * @return Boolean
   */
  public checkSetPlanSingleTerm(strPCode: string,
    strGuideGoodsName: string,
    strCoopName: string,
    strSupplyPrice: string,
    strApprovedNum: string): boolean {

    let strMes: string = <string>'';

    if (strApprovedNum.length < 1) {
      return true;
    }

    // 「セット企画数量」が1以上でない場合
    if (Number(strApprovedNum) < 1) {
      strMes = '『' + strPCode + ':' + strGuideGoodsName + '』のセット企画数量（' + strCoopName + '）';
      this.dialogService.openAlertGetMessage('E0142', [strMes, '1'], null);
      return false;
    }
    return true;
  }

  /**
   * 呼出元画面の再表示を行う
   */
  public refleshKYMW1300(): void {
    this.setKYMW1312Parameter();
  }

  /**
   * セット企画プロモーションＮＯ取得リクエスト用VO設定
   *
   * @return GetSetPlanPromotionNoVO
   */
  public createGetSetPlanPromotionNoVO(): KYMW1312GetSetPlanPromotionNoModel {

    const vo: KYMW1312GetSetPlanPromotionNoModel = new KYMW1312GetSetPlanPromotionNoModel();

    // 受注コード
    vo.orderCode = this.KYMW1312Model.orderCode;

    // 媒体区分
    vo.mediumType = this.KYMW1312Model.mediumType;

    return vo;
  }

  /**
   * セット企画プロモーション商品情報取得リクエスト用VO設定
   *
   * @return GetSetPlanPromotionGoodsInfoVO
   */
  private createGetSetPlanPromotionGoodsInfoVO(): KYMW1312GetSetPlanPromotionGoodsInfoModel {

    const vo: KYMW1312GetSetPlanPromotionGoodsInfoModel = new KYMW1312GetSetPlanPromotionGoodsInfoModel();

    // 受注コード
    vo.orderCode = this.KYMW1312Model.orderCode;

    // プロモーションＮＯ
    vo.promotionNo = this.KYMW1312Model.promotionNo;

    // プロモーション区分
    vo.promotionDiv = this.PROMOTION_DIV_SETPLAN;

    return vo;
  }

  /**
   * セット企画プロモーション情報の反映
   */
  public reflectPromotion(approvedNum: string, approvedPrice: string): void {
    const rowNo: number = this.KYMW1312Model.promotionInfo.findIndex(
      obj => obj.pCode === this.dtg_PromotionInfo.selectedItems[0].pCode);
    this.reflectRow(rowNo, approvedNum, approvedPrice);
  }

  public reflectRow(rowNo: number,
    approvedNum: string,
    approvedPrice: string): void {

    // 「セット企画区分」が'子'の場合のみ一括反映を行う
    // (「セット企画区分」が'親'の場合は何もしない)
    if (this.KYMW1312Model.promotionInfo[rowNo].setPlanDiv === '2') {
      if (this.KYMW1312Model.coopIB === true &&
        this.KYMW1312Model.promotionInfo[rowNo].handlingFlgIB === '1') {
        if (approvedNum.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedNumIB = approvedNum; 
        }
        if (approvedPrice.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedPriceIB = approvedPrice; 
        }
      }

      if (this.KYMW1312Model.coopTO === true &&
        this.KYMW1312Model.promotionInfo[rowNo].handlingFlgTO === '1') {
        if (approvedNum.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedNumTO = approvedNum; 
        }
        if (approvedPrice.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedPriceTO = approvedPrice; 
        }
      }

      if (this.KYMW1312Model.coopGU === true &&
        this.KYMW1312Model.promotionInfo[rowNo].handlingFlgGU === '1') {
        if (approvedNum.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedNumGU = approvedNum; 
        }
        if (approvedPrice.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedPriceGU = approvedPrice; 
        }
      }

      if (this.KYMW1312Model.coopTI === true &&
        this.KYMW1312Model.promotionInfo[rowNo].handlingFlgTI === '1') {
        if (approvedNum.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedNumTI = approvedNum; 
        }
        if (approvedPrice.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedPriceTI = approvedPrice; 
        }
      }

      if (this.KYMW1312Model.coopSA === true &&
        this.KYMW1312Model.promotionInfo[rowNo].handlingFlgSA === '1') {

        if (approvedNum.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedNumSA = approvedNum; 
        }
        if (approvedPrice.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedPriceSA = approvedPrice; 
        }
      }

      if (this.KYMW1312Model.coopTK === true &&
        this.KYMW1312Model.promotionInfo[rowNo].handlingFlgTK === '1') {

        if (approvedNum.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedNumTK = approvedNum; 
        }
        if (approvedPrice.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedPriceTK = approvedPrice; 
        }
      }

      if (this.KYMW1312Model.coopNA === true &&
        this.KYMW1312Model.promotionInfo[rowNo].handlingFlgNA === '1') {

        if (approvedNum.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedNumNA = approvedNum; 
        }
        if (approvedPrice.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedPriceNA = approvedPrice; 
        }
      }

      if (this.KYMW1312Model.coopNI === true &&
        this.KYMW1312Model.promotionInfo[rowNo].handlingFlgNI === '1') {

        if (approvedNum.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedNumNI = approvedNum; 
        }
        if (approvedPrice.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedPriceNI = approvedPrice; 
        }
      }

      if (this.KYMW1312Model.coopKU === true &&
        this.KYMW1312Model.promotionInfo[rowNo].handlingFlgKU === '1') {

        if (approvedNum.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedNumKU = approvedNum; 
        }
        if (approvedPrice.length > 0) {
          this.KYMW1312Model.promotionInfo[rowNo].approvedPriceKU = approvedPrice; 
        }
      }

      this.editCount++;
    }
  }

  /**
   * セット企画プロモーション商品登録リクエスト用VO設定
   *
   * @return RegistPromotionGoodsVO
   */
  private createRegistSetPlanPromotionGoodsVO(): KYMW1312RegistSetPlanPromotionGoodsModel {

    const registSetPlanPromotionGoodsVO: KYMW1312RegistSetPlanPromotionGoodsModel = new KYMW1312RegistSetPlanPromotionGoodsModel();

    if (this.KYMW1312Model.promotionNo == null) {
      registSetPlanPromotionGoodsVO.promotionNo = '';
    } else {
      registSetPlanPromotionGoodsVO.promotionNo = this.KYMW1312Model.promotionNo;
    }
    registSetPlanPromotionGoodsVO.promotionName = this.KYMW1312Model.promotionName;
    registSetPlanPromotionGoodsVO.promotionDiv = this.KYMW1312Model.promotionDiv;
    registSetPlanPromotionGoodsVO.orderCode = this.KYMW1312Model.orderCode;

    const registGoodsList: Array<any> = new Array<any>();

    for (const vo of this.KYMW1312Model.promotionInfo) {

      // いばらき
      this.createRegistVO(registGoodsList, vo, vo.handlingFlgIB, this.kymw00Model.COOP_CODE_IB, vo.approvedNumIB, vo.approvedPriceIB);
      // とちぎ
      this.createRegistVO(registGoodsList, vo, vo.handlingFlgTO, this.kymw00Model.COOP_CODE_TO, vo.approvedNumTO, vo.approvedPriceTO);
      // ぐんま
      this.createRegistVO(registGoodsList, vo, vo.handlingFlgGU, this.kymw00Model.COOP_CODE_GU, vo.approvedNumGU, vo.approvedPriceGU);
      // ちば
      this.createRegistVO(registGoodsList, vo, vo.handlingFlgTI, this.kymw00Model.COOP_CODE_TI, vo.approvedNumTI, vo.approvedPriceTI);
      // さいたま
      this.createRegistVO(registGoodsList, vo, vo.handlingFlgSA, this.kymw00Model.COOP_CODE_SA, vo.approvedNumSA, vo.approvedPriceSA);
      // とうきょう
      this.createRegistVO(registGoodsList, vo, vo.handlingFlgTK, this.kymw00Model.COOP_CODE_TK, vo.approvedNumTK, vo.approvedPriceTK);
      // ながの
      this.createRegistVO(registGoodsList, vo, vo.handlingFlgNA, this.kymw00Model.COOP_CODE_NA, vo.approvedNumNA, vo.approvedPriceNA);
      // にいがた
      this.createRegistVO(registGoodsList, vo, vo.handlingFlgNI, this.kymw00Model.COOP_CODE_NI, vo.approvedNumNI, vo.approvedPriceNI);
      // クルコ
      this.createRegistVO(registGoodsList, vo, vo.handlingFlgKU, this.kymw00Model.COOP_CODE_KU, vo.approvedNumKU, vo.approvedPriceKU);
    }

    registSetPlanPromotionGoodsVO.registGoodsList = registGoodsList;
    return registSetPlanPromotionGoodsVO;
  }

  /**
   * セット企画プロモーション商品登録リクエスト用VO設定（各生協別）
   */
  private createRegistVO(registGoodsList: Array<any>,
    vo: KYMW1312SetPlanPromotionGoodsInfoModel,
    handlingFlg: string,
    coopCode: string,
    approvedNum: string,
    approvedPrice: string): void {

    const registVo: KYMW1312SetPlanPromotionGoodsRegistModel = new KYMW1312SetPlanPromotionGoodsRegistModel();

    if (approvedNum.length > 0 || approvedPrice.length > 0) {

      // Ｐコード
      registVo.pCode = vo.pCode;

      // 媒体区分
      registVo.mediumType = vo.mediumType;

      // 生協コード
      registVo.coopCode = coopCode;

      // セット企画商品名
      registVo.setDelivGoodsName = vo.setDelivGoodsName;

      // セット企画商品名（カナ）
      registVo.setDelivGoodsNameKana = vo.setDelivGoodsNameKana;

      // セット企画規格名
      registVo.setDelivStandardName = vo.setDelivStandardName;

      // セット企画規格名（カナ）
      registVo.setDelivStandardNameKana = vo.setDelivStandardNameKana;

      // セット企画区分
      registVo.setPlanDiv = vo.setPlanDiv;

      // 単品注文可否区分
      registVo.singleOrderFlag = vo.singleOrderFlag;

      // 注文受付可否区分
      registVo.acceptDiv = vo.acceptDiv;

      // 供給可能区分
      registVo.supplyDiv = vo.supplyDiv;

      // セット企画数量
      registVo.approvedNum = approvedNum;

      // 成立価格
      registVo.approvedPrice = approvedPrice;

      registGoodsList.push(registVo);
    }
  }

  /**
   * セット企画プロモーション商品登録情報VO設定
   */
  private createSetPlanPromotionGoodsRegistVO(svo: KYMW1312SetPlanPromotionGoodsInfoModel,
    registGoodsList: Array<any>): void {

    const vo: KYMW1312SetPlanPromotionGoodsRegistModel = new KYMW1312SetPlanPromotionGoodsRegistModel();

    vo.pCode = svo.pCode;                                                       // Ｐコード
    vo.mediumType = svo.mediumType;                                             // 媒体区分
    vo.setDelivGoodsName = svo.setDelivGoodsName;                               // セット企画商品名
    vo.setDelivGoodsNameKana = svo.setDelivGoodsNameKana;                       // セット企画商品名（カナ）
    vo.setDelivStandardName = svo.setDelivStandardName;                         // セット企画規格名
    vo.setDelivStandardNameKana = svo.setDelivStandardNameKana;                 // セット企画規格名（カナ）
    vo.setPlanDiv = svo.setPlanDiv;                                             // セット企画区分
    vo.singleOrderFlag = svo.singleOrderFlag;                                   // 単品注文可否区分
    vo.acceptDiv = svo.acceptDiv;                                               // 注文受付可否区分
    vo.supplyDiv = svo.supplyDiv;                                               // 供給可能区分

    this.createSetPlanPromotionGoodsRegistVOByCoop(
      vo, this.kymw00Model.COOP_CODE_IB, svo.approvedNumIB, svo.approvedPriceIB, registGoodsList);
    this.createSetPlanPromotionGoodsRegistVOByCoop(
      vo, this.kymw00Model.COOP_CODE_TO, svo.approvedNumTO, svo.approvedPriceTO, registGoodsList);
    this.createSetPlanPromotionGoodsRegistVOByCoop(
      vo, this.kymw00Model.COOP_CODE_GU, svo.approvedNumGU, svo.approvedPriceGU, registGoodsList);
    this.createSetPlanPromotionGoodsRegistVOByCoop(
      vo, this.kymw00Model.COOP_CODE_TI, svo.approvedNumTI, svo.approvedPriceTI, registGoodsList);
    this.createSetPlanPromotionGoodsRegistVOByCoop(
      vo, this.kymw00Model.COOP_CODE_SA, svo.approvedNumSA, svo.approvedPriceSA, registGoodsList);
    this.createSetPlanPromotionGoodsRegistVOByCoop(
      vo, this.kymw00Model.COOP_CODE_TK, svo.approvedNumTK, svo.approvedPriceTK, registGoodsList);
    this.createSetPlanPromotionGoodsRegistVOByCoop(
      vo, this.kymw00Model.COOP_CODE_NA, svo.approvedNumNA, svo.approvedPriceNA, registGoodsList);
    this.createSetPlanPromotionGoodsRegistVOByCoop(
      vo, this.kymw00Model.COOP_CODE_NI, svo.approvedNumNI, svo.approvedPriceNI, registGoodsList);
    this.createSetPlanPromotionGoodsRegistVOByCoop(
      vo, this.kymw00Model.COOP_CODE_KU, svo.approvedNumKU, svo.approvedPriceKU, registGoodsList);
  }

  /**
   * セット企画プロモーション商品登録情報VO設定・毎会員生協
   */
  private createSetPlanPromotionGoodsRegistVOByCoop(vo: KYMW1312SetPlanPromotionGoodsRegistModel,
    strCoopCode: string,
    strApprovedNum: string,
    strApprovedPrice: string,
    registGoodsList: Array<any>): void {

    if (strApprovedNum.length > 0) {
      const vo1: any = Object.assign({}, vo);
      vo1.coopCode = strCoopCode;                                               // 生協コード
      vo1.approvedNum = strApprovedNum;                                         // セット企画数量
      vo1.approvedPrice = strApprovedPrice;                                     // 成立価格

      registGoodsList.push(vo1);
    }

    return;
  }

  /**
   * 閲覧モード時コンポーネント編集
   **/
  private enabledForViewer(flg: boolean): void {
    this.KYMW1312Model.disabledPromotionName = !flg;
    this.KYMW1312Model.disabledUnitAll = !flg;
    this.KYMW1312Model.disabledUnitCoop = !flg;
    this.KYMW1312Model.disabledCoopIB = !flg;
    this.KYMW1312Model.disabledCoopTO = !flg;
    this.KYMW1312Model.disabledCoopGU = !flg;
    this.KYMW1312Model.disabledCoopTI = !flg;
    this.KYMW1312Model.disabledCoopSA = !flg;
    this.KYMW1312Model.disabledCoopTK = !flg;
    this.KYMW1312Model.disabledCoopNA = !flg;
    this.KYMW1312Model.disabledCoopNI = !flg;
    this.KYMW1312Model.disabledCoopKU = !flg;
    this.KYMW1312Model.disabledApprovedNum = !flg;
    this.KYMW1312Model.disabledApprovedPrice = !flg;
    this.KYMW1312Model.disabledReflection = !flg;
    if (flg) {
      this.dtg_PromotionInfo.selectionMode = SelectionMode.Row;
    } else {
      this.dtg_PromotionInfo.selectionMode = SelectionMode.None;
    }
    this.dtg_PromotionInfo.isReadOnly = !flg;

    this.setEnabledUnit();
  }

  /**
   * セット企画プロモーション商品情報取得更新
   */
  public updateSetPlanPromotionGoodsInfo(): void {
    // セット企画設定画面用インプットVOのチェック
    if (!PlessViewUtilsSub.isEmpty(this.inputVO.promotionNo)) {
      this.KYMW1312Model.promotionNo = this.inputVO.promotionNo;                // プロモーションＮＯ

      // セット企画プロモーション商品情報取得要求をサーバに送信
      this.getSetPlanPromotionGoodsInfoService.execute(this.KYMW1312Model, this.createGetSetPlanPromotionGoodsInfoVO());
    }
  }

  /**
   * プロモーション情報一覧の一つを「親」にした場合の処理
   */
  public selectParentInSetPlanPromotionInfo(): void {

    this.KYMW1312Model.parentToChildRow = 0;
    for (let i: number = <number>0; i < this.dtg_PromotionInfo.collectionView.items.length; i++) {
      const vo: KYMW1312SetPlanPromotionGoodsInfoModel = this.dtg_PromotionInfo.collectionView.items[i];

      if (i === this.dtg_PromotionInfo.selection.row) {
        vo.singleOrderFlag = this.ABLE;                                         // 「親」商品の「単品注文可否区分」を「1：可能」にする。
        vo.acceptDiv = this.ABLE;                                               // 「親」商品の「注文受付可否区分」を「1：可能」にする。
        vo.supplyDiv = this.UNABLE;                                             // 「親」商品の「供給可能区分」を「0：不可」にする。
      } else {
        // 操作前が「親」だった行の場合
        if (vo.setPlanDiv === this.SETPLAN_DIV_PARENT) {
          // その行の位置を保持
          this.KYMW1312Model.parentToChildRow = i;
        }
        vo.setPlanDiv = this.SETPLAN_DIV_CHILD;                                 // 「親」商品以外の「セット企画区分」を「2：子」にする。
        vo.acceptDiv = this.UNABLE;                                             // 「親」商品以外の「注文受付可否区分」を「0：不可」にする。
        vo.supplyDiv = this.ABLE;                                               // 「親」商品以外の「供給可能区分」を「1：可能」にする。
      }

      vo.setPlanDivOrg = vo.setPlanDiv;                                         // セットされている「セット企画区分」を保持する。
    }
  }

  /**
   * プロモーション情報一覧の一つを「親」にした場合の
   * 「セット企画商品名」、「セット企画商品名(カナ)」、「セット企画規格名」、「セット企画規格名(カナ)」、
   * 「セット企画数量」、「成立価格」のデフォルト値設定
   */
  public setDefaultApprovedNumAndPrice(): void {

    for (let i: number = <number>0; i < this.KYMW1312Model.promotionInfo.length; i++) {
      const vo: KYMW1312SetPlanPromotionGoodsInfoModel = this.KYMW1312Model.promotionInfo[i];

      // 操作している行、または操作前が「親」だった行の場合
      if (i === this.dtg_PromotionInfo.selection.row ||
        i === this.KYMW1312Model.parentToChildRow) {

        // 「セット企画商品名」なとに、企画商品基本マスタの「お届け明細用商品名（漢字）」などを設定
        vo.setDelivGoodsName = this.KYMW1312Model.promotionInfo[i].deliveryGoodsNameKanji;
        vo.setDelivGoodsNameKana = this.KYMW1312Model.promotionInfo[i].deliveryGoodsNameKana;
        vo.setDelivStandardName = this.KYMW1312Model.promotionInfo[i].deliveryStandardNameKanji;
        vo.setDelivStandardNameKana = this.KYMW1312Model.promotionInfo[i].deliveryStandardNameKana;

        // 取扱生協の場合、セット企画数量、成立価格に対して、デフォルト値を設定
        if (this.KYMW1312Model.promotionInfo[i].handlingFlgIB === '1') {
          vo.approvedNumIB = '1';
          vo.approvedPriceIB = this.KYMW1312Model.promotionInfo[i].thisTimeSupplyPriceIB;
        }

        if (this.KYMW1312Model.promotionInfo[i].handlingFlgTO === '1') {
          vo.approvedNumTO = '1';
          vo.approvedPriceTO = this.KYMW1312Model.promotionInfo[i].thisTimeSupplyPriceTO;
        }

        if (this.KYMW1312Model.promotionInfo[i].handlingFlgGU === '1') {
          vo.approvedNumGU = '1';
          vo.approvedPriceGU = this.KYMW1312Model.promotionInfo[i].thisTimeSupplyPriceGU;
        }

        if (this.KYMW1312Model.promotionInfo[i].handlingFlgTI === '1') {
          vo.approvedNumTI = '1';
          vo.approvedPriceTI = this.KYMW1312Model.promotionInfo[i].thisTimeSupplyPriceTI;
        }

        if (this.KYMW1312Model.promotionInfo[i].handlingFlgSA === '1') {
          vo.approvedNumSA = '1';
          vo.approvedPriceSA = this.KYMW1312Model.promotionInfo[i].thisTimeSupplyPriceSA;
        }

        if (this.KYMW1312Model.promotionInfo[i].handlingFlgTK === '1') {
          vo.approvedNumTK = '1';
          vo.approvedPriceTK = this.KYMW1312Model.promotionInfo[i].thisTimeSupplyPriceTK;
        }

        if (this.KYMW1312Model.promotionInfo[i].handlingFlgNA === '1') {
          vo.approvedNumNA = '1';
          vo.approvedPriceNA = this.KYMW1312Model.promotionInfo[i].thisTimeSupplyPriceNA;
        }

        if (this.KYMW1312Model.promotionInfo[i].handlingFlgNI === '1') {
          vo.approvedNumNI = '1';
          vo.approvedPriceNI = this.KYMW1312Model.promotionInfo[i].thisTimeSupplyPriceNI;
        }

        if (this.KYMW1312Model.promotionInfo[i].handlingFlgKU === '1') {
          vo.approvedNumKU = '1';
          vo.approvedPriceKU = this.KYMW1312Model.promotionInfo[i].thisTimeSupplyPriceKU;
        }
      }
    }
  }

  /**
   * 会員生協のインデックスを取得する。
   */
  private indexCoop(coopName: string): number {
    for (let i: number = <number>0; i < this.ARR_COOP_NAME.length; i++) {
      if (this.ARR_COOP_NAME[i] === coopName) {
        return i;
      }
    }
    return -1;
  }

  /**
   * 「セット企画数量」に値がある場合、「成立価格」が未入力ならば、エラーメッセージを表示する。
   * @param strPCode Ｐコード
   * @param strGuideGoodsName strGuideGoodsName
   * @param strCoopName 生協名
   * @param handlingFlg 取扱フラグ
   * @param approvedNum セット企画数量
   * @param approvedPrice 成立価格
   * @return OK:true, NG:false
   */
  private checkApprovedPrice(strPCode: string,
    strGuideGoodsName: string,
    strCoopName: string,
    handlingFlg: string,
    approvedNum: string,
    approvedPrice: string): boolean {

    if (handlingFlg === this.HANDLING_ON) {
      if (approvedNum && !approvedPrice) {
        const strMes: string = '『' + strPCode + ':' + strGuideGoodsName + '』の成立価格（' + strCoopName + '）';
        this.dialogService.openAlertGetMessage('W0001', [strMes], null);
        return false;
      }
    }

    return true;
  }

  /**
   * プロモーション情報一覧の各会員生協について、集計オブジェクトを作る。
   * @param promotionInfo : プロモーション情報
   * @return 集計配列
   */
  private createArrCheckMatrics(promotionInfo: Array<any>): Array<any> {

    const arr: Array<any>
      = [new Object(), new Object(), new Object(), new Object(), new Object(), new Object(), new Object(), new Object(), new Object()];

    // 集計配列を初期化する。
    for (let i: number = <number>0; i < this.ARR_COOP_NAME.length; i++) {
      arr[i].coopName = this.ARR_COOP_NAME[i];
      arr[i].childrenNum = 0;
      arr[i].approvedPriceSum = 0;
    }

    for (let j: number = <number>0; j < promotionInfo.length; j++) {

      const vo: KYMW1312SetPlanPromotionGoodsInfoModel = <KYMW1312SetPlanPromotionGoodsInfoModel>(promotionInfo[j]);

      if (vo.setPlanDiv === this.SETPLAN_DIV_PARENT) {
        // 親商品
        this.createArrCheckMatricsParent(arr, vo);
      } else {
        // 子商品
        this.createArrCheckMatricsChild(arr, vo);
      }
    }

    return arr;
  }

  /**
   * 親商品のプロモーション商品情報から集計情報を取得する。
   *
   * @param arr : 集計配列
   * @param vo : プロモーション商品情報
   */
  private createArrCheckMatricsParent(arr: Array<any>, vo: KYMW1312SetPlanPromotionGoodsInfoModel): void {
    // 親商品の取扱フラグ
    arr[this.indexCoop(this.kymw00Model.COOP_IB)].handlingFlg = vo.handlingFlgIB;   // いばらき
    arr[this.indexCoop(this.kymw00Model.COOP_TO)].handlingFlg = vo.handlingFlgTO;   // とちぎ
    arr[this.indexCoop(this.kymw00Model.COOP_GU)].handlingFlg = vo.handlingFlgGU;   // ぐんま
    arr[this.indexCoop(this.kymw00Model.COOP_TI)].handlingFlg = vo.handlingFlgTI;   // ちば
    arr[this.indexCoop(this.kymw00Model.COOP_SA)].handlingFlg = vo.handlingFlgSA;   // さいたま
    arr[this.indexCoop(this.kymw00Model.COOP_TK)].handlingFlg = vo.handlingFlgTK;   // とうきょう
    arr[this.indexCoop(this.kymw00Model.COOP_NA)].handlingFlg = vo.handlingFlgNA;   // ながの
    arr[this.indexCoop(this.kymw00Model.COOP_NI)].handlingFlg = vo.handlingFlgNI;   // にいがた
    arr[this.indexCoop(this.kymw00Model.COOP_KU)].handlingFlg = vo.handlingFlgKU;   // クルコ

    // 親商品のセット企画数量
    arr[this.indexCoop(this.kymw00Model.COOP_IB)].approvedNum = vo.approvedNumIB;   // いばらき
    arr[this.indexCoop(this.kymw00Model.COOP_TO)].approvedNum = vo.approvedNumTO;   // とちぎ
    arr[this.indexCoop(this.kymw00Model.COOP_GU)].approvedNum = vo.approvedNumGU;   // ぐんま
    arr[this.indexCoop(this.kymw00Model.COOP_TI)].approvedNum = vo.approvedNumTI;   // ちば
    arr[this.indexCoop(this.kymw00Model.COOP_SA)].approvedNum = vo.approvedNumSA;   // さいたま
    arr[this.indexCoop(this.kymw00Model.COOP_TK)].approvedNum = vo.approvedNumTK;   // とうきょう
    arr[this.indexCoop(this.kymw00Model.COOP_NA)].approvedNum = vo.approvedNumNA;   // ながの
    arr[this.indexCoop(this.kymw00Model.COOP_NI)].approvedNum = vo.approvedNumNI;   // にいがた
    arr[this.indexCoop(this.kymw00Model.COOP_KU)].approvedNum = vo.approvedNumKU;   // クルコ

    // 親商品の今回供給価格
    arr[this.indexCoop(this.kymw00Model.COOP_IB)].thisTimeSupplyPrice = Number(vo.thisTimeSupplyPriceIB);   // いばらき
    arr[this.indexCoop(this.kymw00Model.COOP_TO)].thisTimeSupplyPrice = Number(vo.thisTimeSupplyPriceTO);   // とちぎ
    arr[this.indexCoop(this.kymw00Model.COOP_GU)].thisTimeSupplyPrice = Number(vo.thisTimeSupplyPriceGU);   // ぐんま
    arr[this.indexCoop(this.kymw00Model.COOP_TI)].thisTimeSupplyPrice = Number(vo.thisTimeSupplyPriceTI);   // ちば
    arr[this.indexCoop(this.kymw00Model.COOP_SA)].thisTimeSupplyPrice = Number(vo.thisTimeSupplyPriceSA);   // さいたま
    arr[this.indexCoop(this.kymw00Model.COOP_TK)].thisTimeSupplyPrice = Number(vo.thisTimeSupplyPriceTK);   // とうきょう
    arr[this.indexCoop(this.kymw00Model.COOP_NA)].thisTimeSupplyPrice = Number(vo.thisTimeSupplyPriceNA);   // ながの
    arr[this.indexCoop(this.kymw00Model.COOP_NI)].thisTimeSupplyPrice = Number(vo.thisTimeSupplyPriceNI);   // にいがた
    arr[this.indexCoop(this.kymw00Model.COOP_KU)].thisTimeSupplyPrice = Number(vo.thisTimeSupplyPriceKU);   // クルコ
  }

  /**
   * 子商品のプロモーション商品情報を集計する。
   *
   * @param arr : 集計配列
   * @param vo : プロモーション商品情報
   */
  private createArrCheckMatricsChild(arr: Array<any>, vo: KYMW1312SetPlanPromotionGoodsInfoModel): void {

    this.createArrCheckMatricsChildByCoop(
      arr[this.indexCoop(this.kymw00Model.COOP_IB)], vo.handlingFlgIB, vo.approvedNumIB, vo.approvedPriceIB); // いばらき
    this.createArrCheckMatricsChildByCoop(
      arr[this.indexCoop(this.kymw00Model.COOP_TO)], vo.handlingFlgTO, vo.approvedNumTO, vo.approvedPriceTO); // とちぎ
    this.createArrCheckMatricsChildByCoop(
      arr[this.indexCoop(this.kymw00Model.COOP_GU)], vo.handlingFlgGU, vo.approvedNumGU, vo.approvedPriceGU); // ぐんま
    this.createArrCheckMatricsChildByCoop(
      arr[this.indexCoop(this.kymw00Model.COOP_TI)], vo.handlingFlgTI, vo.approvedNumTI, vo.approvedPriceTI); // ちば
    this.createArrCheckMatricsChildByCoop(
      arr[this.indexCoop(this.kymw00Model.COOP_SA)], vo.handlingFlgSA, vo.approvedNumSA, vo.approvedPriceSA); // さいたま
    this.createArrCheckMatricsChildByCoop(
      arr[this.indexCoop(this.kymw00Model.COOP_TK)], vo.handlingFlgTK, vo.approvedNumTK, vo.approvedPriceTK); // とうきょう
    this.createArrCheckMatricsChildByCoop(
      arr[this.indexCoop(this.kymw00Model.COOP_NA)], vo.handlingFlgNA, vo.approvedNumNA, vo.approvedPriceNA); // ながの
    this.createArrCheckMatricsChildByCoop(
      arr[this.indexCoop(this.kymw00Model.COOP_NI)], vo.handlingFlgNI, vo.approvedNumNI, vo.approvedPriceNI); // にいがた
    this.createArrCheckMatricsChildByCoop(
      arr[this.indexCoop(this.kymw00Model.COOP_KU)], vo.handlingFlgKU, vo.approvedNumKU, vo.approvedPriceKU); // クルコ
  }

  /**
   * 子商品のプロモーション商品情報を集計する。
   *
   * @param element : 集計配列要素
   * @param handlingFlg : 取扱フラグ
   * @param approvedNum : セット企画数量
   * @param approvedPrice : 成立価格
   */
  private createArrCheckMatricsChildByCoop(
    element: any, handlingFlg: string, approvedNum: string, approvedPrice: string): void {

    if (handlingFlg === this.HANDLING_ON && approvedNum && approvedPrice) {
      // 子商品数量
      element.childrenNum += 1;
      // 商品成立価格合計
      element.approvedPriceSum += Number(approvedNum) * Number(approvedPrice);
    }
  }

  /**
   * 編集カウントをクリアする。
   */
  private clearEditCount(): void {
    this.editCount = 0;
  }

  /**
   * プロモーションNo再取得
   *
   * @memberof KYMW1308Component
   */
  public refleshPromotionNo(): void {
    // プロモーションＮＯ取得要求をサーバに送信
    this.getSetPromotionNoService.execute(this.KYMW1312Model, this.createGetSetPlanPromotionNoVO());
  }

  /**
   * セット企画区分変更時イベント
   *
   * @param {Event} event
   * @memberof KYMW1312Component
   */
  public eventSetPlanDiv_CHANGEHandler(): void {
    // プロモーション情報一覧の一つを「親」にした場合の処理
    this.selectParentInSetPlanPromotionInfo();
    this.setDefaultApprovedNumAndPrice();
    this.editCount++;
  }

  /**
   * 単品注文可否区分変更時イベント
   *
   * @param {Event} event
   * @memberof KYMW1312Component
   */
  public eventSingleOrderFlag_CHANGEHandler(event: Event): void {
    this.editCount++;
  }

  /**
  * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
  *
  * @param {*} param 受け渡すデータ
  * @memberof KYMW9100Component
  */
  public setInterfaceParam(param: any): void {
    this.inputVO = param;
  }

  /**
   * セット企画商品名（カナ）、セット企画規格名（カナ）の入力から半角カンマを削除
   * @param cell セル
   * @param e イベント
   */
  public deleteCommaHandler(cell: any): void {
    cell.value = cell.value.replace(/,/g, '');
  }
}
